var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 37,
    viewBox: "0 0 32 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25262 29.1901L12.1782 26.4721C12.3884 26.412 12.5836 26.2994 12.7413 26.1417L28.7414 10.1417C30.2505 8.63254 30.2505 6.18482 28.7414 4.6757L25.1975 1.13184C23.6884 -0.37728 21.2407 -0.37728 19.7315 1.13184L3.73148 17.1319C3.5738 17.2896 3.46118 17.4848 3.40112 17.695L0.683135 27.6281C0.563004 28.0711 0.690643 28.5442 1.01349 28.867C1.25376 29.1073 1.58412 29.2424 1.91448 29.2424C2.0271 29.2349 2.13999 29.2201 2.25262 29.1901ZM5.29296 20.4734L9.40748 24.5879L3.73881 26.1421L5.29296 20.4734Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7236 33.6133H1.27641C0.570656 33.6133 0 34.1839 0 34.8897C0 35.5955 0.570622 36.1661 1.27641 36.1661H30.7236C31.4293 36.1661 32 35.5955 32 34.8897C32 34.1839 31.4294 33.6133 30.7236 33.6133Z",
    fill: "#444444"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.3edb91b93780be00c3fc8d3ee7091ed0.svg";
export { ForwardRef as ReactComponent };